import React from "react";
import Layout from "./components/Layout";
import CustomCursor from "./components/CustomCursor";
import OrbitalBackground from "./components/OrbitalBackground";
import BrandHeader from "./components/BrandHeader";
import Carousel from "./components/Carousel";
import ContactButton from "./components/ContactButton";

function App() {
  return (
    <Layout>
      <OrbitalBackground />
      <CustomCursor />
      <BrandHeader />
      <div className="relative z-10 flex flex-col items-center justify-center flex-1 w-full px-6">
        <Carousel />
        <ContactButton />
      </div>
    </Layout>
  );
}

export default App;